import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import backgroundImage from '../assets/background.jpg';
import kidneyImage from '../assets/kidney.jpg'; 

const Hero = () => {
  const heroStyles = {
    backgroundImage: `url(${backgroundImage})`
  };

  return (
    <section className="hero" style={heroStyles}>
      <div className="container hero-container">
        <div className="hero-content">
          <h2 className="hero-subtitle">Polycystic Kidney Disease (PKD)</h2>
          <h1>Awareness, Support & Hope</h1>
          <p>Learn how PKD affects you and your family</p>
          <a href="#contact" className="btn">
            Contact us to understand PKD <FaArrowRight />
          </a>
        </div>
        <div className="hero-image-container">
          <img src={kidneyImage} alt="Illustration of a polycystic kidney" />
        </div>
      </div>
    </section>
  );
};

export default Hero;